import { WriteWhiteHouseForm } from "QuorumGrassroots/campaign-forms/components/WriteWhiteHouseForm"

import { getMessageFormWrapper } from "QuorumGrassroots/campaign-forms/wrappers/GetMessagesFormWrapper"
import { generateGrassrootsActionsWithImmutableValues } from "QuorumGrassroots/campaign-forms/helpers"
import { generateWriteWhiteHouseActions } from "QuorumGrassroots/campaign-forms/grassrootsActionGenerators"

export default getMessageFormWrapper({
    formName: "write_white_house",
    generateGrassrootsActions: (messageValues, globalFormValues, props) =>
        generateGrassrootsActionsWithImmutableValues(
            generateWriteWhiteHouseActions,
            messageValues,
            globalFormValues,
            props,
        ),
})(WriteWhiteHouseForm)
